import { useCallback, useState } from "react";
import { toast } from "react-toastify";

import { ManageService } from "../services/Services";
import { cryptoUtil } from "../services/utils/CryptoUtil";
import Builders from "../services/utils/Builders";

export const useSignup = () => {
    const [isLoading, setIsLoading] = useState(false);

    const createAccount = useCallback(async userData => {
        setIsLoading(true);
        try {
            const { firstname, lastname } = cryptoUtil.getNamesUser(userData.name);

            const createUserModel = Builders.buildCreateUserPayload(
                userData.email,
                firstname,
                lastname,
                userData.phone,
            );
            const responseCreateUser = await ManageService.createUserCryptofacil(createUserModel);
            console.log("responseCreateUser createAccount hook", responseCreateUser);

            return responseCreateUser;
        } catch (error) {
            console.log("error createAccount hook", error);
            toast.error(error.message);
        } finally {
            setIsLoading(false);
        }
    }, []);

    return { isLoading, createAccount };
};
